import { ArrowUpRight } from "lucide-react";
import type { DemoRegistryItem } from "../data/demoRegistry";
import { useI18n } from "../i18n/i18n";
import { catalogueMessages } from "../i18n/messages";

export function DemoCard({ demo }: { demo: DemoRegistryItem }) {
  const { language, text } = useI18n();
  const previewAlt = `${demo.brand} — ${language.toUpperCase()} preview`;
  return (
    <article className="demo-card">
      <a className={`demo-card-preview preview-${demo.id}`} href={demo.route} aria-label={`${text(catalogueMessages.open)}: ${text(demo.title)}`} style={{ backgroundColor: demo.accentSoft }}>
        <span className="safari-window">
          <span className="safari-toolbar" aria-hidden="true">
            <span className="safari-controls"><i /><i /><i /></span>
            <span className="safari-address">mattiadelia.com{demo.route}</span>
          </span>
          <span className="safari-screen">
            <img src={text(demo.previewAsset)} alt={previewAlt} width="1200" height="750" loading="lazy" decoding="async" />
          </span>
        </span>
        <span className="iphone-frame" aria-hidden="true">
          <span className="iphone-screen" style={{ backgroundImage: `url(${text(demo.previewMobileAsset ?? demo.previewAsset)})` }} />
          <span className="iphone-home" />
        </span>
      </a>
      <div className="demo-card-body">
        <h3>{text(demo.title)}</h3>
        <p className="demo-card-outcome">{text(demo.outcome)}</p>
        <div className="demo-card-compatibility">
          <p className="demo-card-compatibility-title">{text(catalogueMessages.related)}</p>
          <ul>{text(demo.relatedIndustries).map((industry) => <li key={industry}>{industry}</li>)}</ul>
        </div>
        <a className="demo-card-action" href={demo.route}>{text(catalogueMessages.open)} <ArrowUpRight size={17} /></a>
      </div>
    </article>
  );
}
